import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarProfessorLayer from "../components/CadastrarProfessorLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarProfessorPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("professor.breadcrumb.create")} />
      <CadastrarProfessorLayer />
    </MasterLayout>
  );
};

export default CadastrarProfessorPage;
